import axios from 'config/api';
import {
  ADD_ARTICLE_COMMENT_ERROR,
  ADD_ARTICLE_COMMENT_SUCCESS,
  FETCH_ARTICLE_COMMENTS_ERROR,
  FETCH_ARTICLE_COMMENTS_SUCCESS,
  FETCH_ARTICLES_SUCCESS,
  FETCH_ARTICLE_SUCCESS,
  RESET_ARTICLE_COMMENTS,
  UPDATE_ARTICLE_COMMENTS_ERROR,
  UPDATE_ARTICLE_COMMENTS_SUCCESS,
  UPDATE_ARTICLE_SUCCESS,
  RESET_ARTICLES,
  REMOVE_ARTICLE_COMMENT_SUCCESS,
  REMOVE_ARTICLE_COMMENT_ERROR,
  SET_ARTICLE_EVENTS,
} from 'config/constants';

export function fetchArticles(page = 1) {
  return axios
    .get('/articles?page=' + page)
    .then(({ data }) => {
      return {
        type: FETCH_ARTICLES_SUCCESS,
        articles: data.rows,
      };
    })
    .catch(error => {
      return error;
    });
}

export function resetArticles() {
  return {
    type: RESET_ARTICLES,
    articles: [],
  };
}

export function findBySlug(slug) {
  return axios.get(`/articles/${slug}/find`).then(({ data }) => {
    return {
      type: 'FIND_ARTICLE_BY_SLUG',
      data: data,
    };
  });
}

export function fetchAllArticles() {
  return axios.get('admin/articles').then(({ data }) => {
    return {
      type: FETCH_ARTICLES_SUCCESS,
      data: data,
    };
  });
}

export function fillArticle(id) {
  return axios.get(`admin/articles/${id}`).then(({ data }) => {
    return {
      type: FETCH_ARTICLE_SUCCESS,
      data: data,
    };
  });
}

export function updateArticle(id, article, token) {
  return axios.put(`/admin/articles/${id}`, article).then(({ data }) => {
    return {
      type: UPDATE_ARTICLE_SUCCESS,
      data: data,
    };
  });
}

export function addComment(id, comment) {
  return axios
    .post(`/user/articles/${id}/comments`, { comment })
    .then(response => {
      const { data, status } = response;
      console.warn('addComment', data);
      if (status === 200) {
        console.warn('status', status);
        return {
          type: ADD_ARTICLE_COMMENT_SUCCESS,
          comment: data,
        };
      }

      throw response;
    })
    .catch(error => {
      const {
        response: { data, status },
      } = error;
      console.warn('addComment-error', error);
      if (data && (status === 400 || status === 403 || status === 422)) {
        console.warn('addComment-error-data', data);
        return {
          type: ADD_ARTICLE_COMMENT_ERROR,
          message: data.error,
        };
      }
      throw error;
    });
}

export function fetchArticleComments(id) {
  console.warn({ id });
  return axios
    .get(`/articles/${id}/comments`)
    .then(response => {
      const { data, status } = response;
      console.warn('fetchArticleComments', data);
      if (status === 200) {
        console.warn('status', status);
        const { comments } = data;
        return {
          type: FETCH_ARTICLE_COMMENTS_SUCCESS,
          comments,
          event: { data, id },
        };
      }

      throw response;
    })
    .catch(error => {
      const {
        response: { data, status },
      } = error;
      console.warn('fetchArticleComments-error', error);
      if (
        data &&
        (status === 400 ||
          status === 401 ||
          status === 403 ||
          status === 404 ||
          status === 422)
      ) {
        console.warn('fetchArticleComments-error-data', data);
        return {
          type: FETCH_ARTICLE_COMMENTS_ERROR,
          message: data.error,
        };
      }
      throw error;
    });
}

export function addArticleEvent(id, type) {
  console.warn({ id, type });
  return axios
    .post(`/user/comments/${id}/event`, { type })
    .then(response => {
      const { data, status } = response;
      console.warn('addArticleEvent', data);
      if (status === 200) {
        console.warn('status', status);
        return {
          type: UPDATE_ARTICLE_COMMENTS_SUCCESS,
          comment: data,
        };
      }

      throw response;
    })
    .catch(error => {
      const {
        response: { data, status },
      } = error;
      console.warn('addArticleEvent-error', error);
      if (
        data &&
        (status === 400 ||
          status === 401 ||
          status === 403 ||
          status === 404 ||
          status === 422)
      ) {
        console.warn('addArticleEvent-error-data', data);
        return {
          type: UPDATE_ARTICLE_COMMENTS_ERROR,
          message: data.error,
        };
      }
      throw error;
    });
}

export async function resetArticleComments() {
  return {
    type: RESET_ARTICLE_COMMENTS,
  };
}

export async function removeArticleComment(id) {
  return axios
    .delete(`/user/comments/${id}`)
    .then(response => {
      const { status } = response;
      if (status === 200) {
        return {
          type: REMOVE_ARTICLE_COMMENT_SUCCESS,
          comment: id,
        };
      }

      throw response;
    })
    .catch(error => {
      const {
        response: { data },
      } = error;

      return {
        type: REMOVE_ARTICLE_COMMENT_ERROR,
        message: data.error,
      };
    });
}
export function setArticleEvents(article) {
  return {
    type: SET_ARTICLE_EVENTS,
    event: { article },
  };
}
